import type { AppModule, ModuleDirectus, ModuleKey, ModuleTenantDirectus } from '@/types/models/module'

const normalize = (value: string) => value
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase()

const configuredModuleHrefs: Partial<Record<ModuleKey, string>> = {
  core: process.env.NEXT_PUBLIC_BASE_PATH,
  zap: process.env.NEXT_PUBLIC_URBAN_ZAP_BASE_PATH,
  comunicaciones: process.env.NEXT_PUBLIC_URBAN_COMUNICACIONES_BASE_PATH,
}

const normalizeHref = (value: string) => {
  const href = value.trim()
  if (!href) return null
  return href.startsWith('/') || /^[a-z][a-z\d+.-]*:\/\//i.test(href)
    ? href
    : `/${href}`
}

export const getModuleKey = (module: AppModule): ModuleKey => {
  const name = normalize(module.name)
  if (name.includes('zap')) return 'zap'
  if (name.includes('comunic')) return 'comunicaciones'
  return 'core'
}

export const getModuleHref = (module: AppModule) => {
  const configuredHref = configuredModuleHrefs[getModuleKey(module)]
  if (configuredHref) {
    const href = normalizeHref(configuredHref)
    if (href) return href
  }

  return normalizeHref(module.slug) || '/urban-studio'
}

export const hasModule = (modules: AppModule[], key: ModuleKey) =>
  modules.some((module) => getModuleKey(module) === key)

export const mapModuleRelation = (relation: ModuleTenantDirectus): AppModule | null => {
  if (!relation.modulos_id || typeof relation.modulos_id !== 'object') return null
  const directusModule = relation.modulos_id as ModuleDirectus
  return {
    id: directusModule.id,
    name: directusModule.nombre,
    description: directusModule.descripcion || '',
    slug: directusModule.slug,
    sort: directusModule.sort,
    icon: directusModule.icon || null,
  }
}
